// @flow
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import {FirebaseAppProvider, SuspenseWithPerf} from "reactfire";
import firebaseConfig from "./firebaseConfig";
import BackdropLoading from "./components/BackdropLoading";

/**
 * TODO: App
 * - Tickets stornieren
 * - Tickets ändern
 * - Tickets schön anzeigen
 *
 * - Anzeige Ticket bei der GameCard
 *
 * - Behandlung des "Ausverkauft"-Status
 *
 * - Tracking des Kaufprozesses
 *
 * TODO: Kasse
 * - Tickets kontrollieren
 * - Besucherzähler
 *
 * TODO: Technical
 * - write tests for firestore rules: https://firebase.google.com/docs/firestore/security/test-rules-emulator
 * - create ios splash screen https://felixgerschau.com/how-to-make-your-react-app-a-progressive-web-app-pwa/#making-it-ios-compatible
 * - server side rendering https://www.youtube.com/watch?v=82tZAPMHfT4&t=607s
 * - create local debugging flow with script https://medium.com/firebase-developers/how-to-import-production-data-from-cloud-firestore-to-the-local-emulator-e82ae1c6ed8
 *
 * - create redirect when not logged in with cookie memory of path to go to
 */

ReactDOM.render(
  <React.StrictMode>
    <FirebaseAppProvider firebaseConfig={firebaseConfig}>
      <SuspenseWithPerf traceId="App" fallback={<BackdropLoading />}>
        <App />
      </SuspenseWithPerf>
    </FirebaseAppProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

// serviceWorker is registered in UpdatePWA
// serviceWorker.register();
